import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import LabeledCheckbox from 'modules/core/components/Inputs/LabeledCheckbox'
import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

interface Props {
  form: Form
  isFiredByCompany: boolean
}

const PreWarning = ({ form, isFiredByCompany }: Props) => {
  const preWarningOptions = useMemo<SelectOption[]>(
    () => [
      {
        label: isFiredByCompany
          ? i18n.t('employees.termination.pre_warning_by_company')
          : i18n.t('employees.termination.pre_warning_by_employee'),
        value: true,
      },
      {
        label: isFiredByCompany
          ? i18n.t('employees.termination.no_pre_warning_by_company')
          : i18n.t('employees.termination.no_pre_warning_by_employee'),
        value: false,
      },
    ],
    [isFiredByCompany]
  )

  const preWarned = form.get('pre_warning').value !== 'false'

  return (
    <>
      <FormRow>
        <Select
          label={i18n.t('employees.termination.pre_warning_label')}
          field={form.get('pre_warning')}
          options={preWarningOptions}
        />
      </FormRow>
      {preWarned && (
        <>
          <FormRow>
            <Text
              label={i18n.t('employees.termination.unfullfiled_pre_warning_days_label')}
              placeholder={i18n.t('employees.termination.unfullfiled_pre_warning_days_placeholder')}
              field={form.get(
                isFiredByCompany
                  ? 'unfullfiled_pre_warning_days_by_company'
                  : 'unfullfiled_pre_warning_days_by_employee'
              )}
            />
          </FormRow>
          <FormRow>
            <LabeledCheckbox
              label={i18n.t('employees.termination.pre_warning_discount')}
              field={form.get('pre_warning_discount')}
            />
          </FormRow>
        </>
      )}
    </>
  )
}

export default observer(PreWarning)
